import { NativeModules, Platform } from 'react-native';
import { isMacAppStore } from '@/lib/appDistribution';

// Only use a fresh, fast response from our HTTPS API. Date has one-second
// precision, comfortably inside the unchanged server proof window. Older
// binaries keep using their system clock until they receive a native update.
export async function syncMacDeviceProofClock(response, url, elapsedMs) {
  const native = NativeModules?.MacRemoteAccess;
  if (Platform.OS !== 'macos' || isMacAppStore() || !native?.updateDeviceProofTime ||
      !url.startsWith('https://') || (!response.ok && response.status !== 401) || !Number.isFinite(elapsedMs) || elapsedMs < 0 || elapsedMs > 5000 ||
      Number(response.headers?.get?.('age') || 0) !== 0 ||
      !/\bno-store\b/i.test(response.headers?.get?.('cache-control') || '')) return;
  const timestamp = Date.parse(response.headers?.get?.('date'));
  if (!Number.isSafeInteger(timestamp) || timestamp <= 0) return;
  try { await native.updateDeviceProofTime(timestamp); }
  catch { /* Clock synchronization must not hide a successful API response. */ }
}
